function factory({ window, document, thn }) {

  const engine = {};

  return engine;

}

export { factory };
